const householdSec1_Object = (payload) => {
  return {
    type: "householdSec1",
    payload,
  };
};

export default householdSec1_Object;
